// extracted by mini-css-extract-plugin
export default {"productDetailHeader":"ProductHeader_productDetailHeader__m7ylF","customIcon":"ProductHeader_customIcon__n4Nx2"};